<script setup>
import FormErrors from "../Errors/FormErrors.vue";
import {reactive, ref} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";
import EditableBtn from "../../../portal-editable-fields/EditableBtn.vue";
import Alert from "../../../../../elements/Alert.vue";
import EditableTextField from "../../../portal-editable-fields/EditableTextField.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const formDataErrors = reactive({
            responseError: null,
            validationErrors: null,
        });

const formDataEmailSendSuccessfully = ref(false);

const formData = reactive({
    email: '',
});

const sendingFormData = ref(false);

const requestPasswordReset = async () => {
    formDataErrors.responseError = null;
    formDataErrors.validationErrors = null;
    sendingFormData.value = true;
    formDataEmailSendSuccessfully.value = false;

    axios.post(route('partners_int.password.request'), formData)
        .then((response) => {
            if (+response.data.status === 1) {
                formDataEmailSendSuccessfully.value = true;
            } else {
                formDataErrors.responseError = response.data?.error;
            }
        }).catch(error => {
            if (error.response.status === 422) {
                formDataErrors.validationErrors = error.response?.data?.errors;
            } else {
                console.log('Login error:', error.response);
                formDataErrors.responseError = error.response?.data?.error || "Something went wrong. See console for details.";
            }
        }).finally(() => {
            sendingFormData.value = false;
    })


    try {
    } catch (error) {
        if (error.response.status === 422) {
            formDataErrors.validationErrors = error.response.data.errors;
        } else {
            formDataErrors.responseError = error.response.data.message;
        }
    }
};

</script>

<template>
    <div :class="portalContentAndDesignStore.getPageContainerClasses">
        <form id="partners-forgotten-password-form">
            <div class="mb-6 space-y-4">

                <form-errors :store-form-errors="formDataErrors"/>
                <alert v-if="formDataEmailSendSuccessfully"
                       type="success"
                >
                    {{ portalContentAndDesignStore.translationSettings.portal_translation_pass_reset_password_info_sent }}
                </alert>

                <div>
                    <editable-text-field
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_pass_reset_email_address"
                        for-attribute="email"
                        class="block text-sm opacity-80 mb-1.5"
                        :class="portalContentAndDesignStore.getPageContentTextColorClass"
                        text-type="label"
                    />
                    <input
                        type="email"
                        name="email"
                        id="email"
                        :class="portalContentAndDesignStore.getInputStyle"
                        v-model="formData.email"
                    >
                </div>
            </div>
            <editable-btn
                :prevent-double-click="5000"
                :disabled="sendingFormData"
                :loading="sendingFormData"
                size="huge"
                class="w-full"
                :type="portalContentAndDesignStore.getPageContentButtonColorClass"
                :corners="portalContentAndDesignStore.getPublicPageButtonCorners"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_pass_reset_send_password_link"
                @click="requestPasswordReset"
            />

            <div class="pt-6 text-sm text-center">
                <editable-text-field
                    text-type="a"
                    :href="portalContentAndDesignStore.getLoginRoute"
                    :class="[
                        'hover:underline text-opacity-100',
                        portalContentAndDesignStore.getLinkColorClass
                    ]"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_pass_reset_back_to_login"
                >
                </editable-text-field>
            </div>
        </form>
    </div>
</template>
